export enum DrawerState {
  PEEK = 'peek',
  DEFAULT = 'default',
  FULL = 'full'
}
